import React, { useEffect, useState } from "react";
import "./Edit_offcanvas.css";
import Select from "react-select";
import { Button, Form, Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import successAnimation from "../../../../../../../animation/success_lottie/Success_lottie.json";
import Blue_btn from "../../../../../../../common_components/common_btn/blue_btn/Blue_btn";
import Blue_border_button from "../../../../../../../common_components/common_btn/blue_border_button/Blue_border_button";
import Success_modal from "../../../../../../../common_components/common_modal/success_modal/Success_modal";
import { useDispatch } from "react-redux";
import {
  GetAll,
  GetSingle,
  Update,
} from "../../../../../../../../features/admin/website/home/SuccessSpeaks/slice";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { IDS } from "../../../../../../../../utils/IDS";

function Edit_offcanvas({
  show,
  showError,
  setShowError,
  setShow,
  setSuccess,
  setErr,
  handleClose,
  setShowRejectModal,
}) {
  const [modalSuccessShow, setModalsuccessShow] = useState(false);

  const dispatch = useDispatch();
  const [defaultValues, setDefaultValues] = useState({});
  const {
    register,
    handleSubmit,
    reset,
    watch,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      description: "",
      college: "",
      country: "",
      rating: "",
      description: "",
      image: "",
    },
  });
  const imageFile = watch("image");

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();

      sendData.append("name", data?.name || "");
      sendData.append("description", data?.description || "");
      sendData.append("college", data?.college || "");
      sendData.append("country", data?.country || "");
      sendData.append("rating", data?.rating || "");

      if (data?.image && data.image.length > 0) {
        sendData.append("image", data.image[0]);
      }
      const res = await dispatch(Update({ id: data.id, data: sendData }));

      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(GetAll());

        setModalsuccessShow(true); // ✅ SHOW SUCCESS MODAL
        setShow(false); // close offcanvas
        setSuccess(true); // optional parent flag
      } else {
        setShow(false);
        setShowRejectModal(true);
      }
    } catch (error) {
      setShow(false);
      setShowRejectModal(true);
    }
  };

  useEffect(() => {
    if (modalSuccessShow) {
      const timer = setTimeout(() => {
        setModalsuccessShow(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [modalSuccessShow]);

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));
      setDefaultValues({
        id: res?.payload?.data?.id,
        name: res?.payload?.data?.name,
        description: res?.payload?.data?.description,
        rating: res?.payload?.data?.rating,
        country: res?.payload?.data?.country,
        college: res?.payload?.data?.college,
        image: res?.payload?.data?.image,
      });
    } catch (error) {
      console.error(error);
      setShow(false);
      setErr(true);
    }
  };

  useEffect(() => {
    if (show) {
      GetData(show);
    }
  }, [show]);

  useEffect(() => {
    if (defaultValues?.id) {
      reset(defaultValues);
    }
  }, [defaultValues, reset]);

  return (
    <>
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        className="view_application_canvas common_offcanvas"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Edit</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="form_holder">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="row">
                {/* Full Name */}
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Name"
                      className={classNames("", { "is-invalid": errors?.name })}
                      {...register("name", {
                        required: "Name is required",
                      })}
                    />
                    {errors?.name && (
                      <Form.Text className="text-danger">
                        {errors?.name?.message}
                      </Form.Text>
                    )}
                    {showError && (
                      <Form.Text className="text-danger">{showError}</Form.Text>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>College</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter College"
                      className={classNames("", { "is-invalid": errors?.name })}
                      {...register("college", {
                        required: "College is required",
                      })}
                    />
                    {errors?.college && (
                      <Form.Text className="text-danger">
                        {errors?.college?.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Country</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Country"
                      className={classNames("", { "is-invalid": errors?.name })}
                      {...register("country", {
                        required: "Country is required",
                      })}
                    />
                    {errors?.country && (
                      <Form.Text className="text-danger">
                        {errors?.country?.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Rating</Form.Label>

                    <Form.Control
                      type="number"
                      placeholder="Enter Rating"
                      min={1}
                      max={5}
                      step={1}
                      className={classNames("", {
                        "is-invalid": errors?.rating,
                      })}
                      onKeyDown={(e) => {
                        // 🚫 block invalid characters
                        if (["-", "e", "+", "."].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      {...register("rating", {
                        required: "Rating is required",
                        valueAsNumber: true,
                        min: {
                          value: 1,
                          message: "Rating must be at least 1",
                        },
                        max: {
                          value: 5,
                          message: "Rating cannot be more than 5",
                        },
                      })}
                    />

                    {errors?.rating && (
                      <Form.Text className="text-danger">
                        {errors?.rating.message}
                      </Form.Text>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                {/* Full Name */}
                <div className="col-md-4 mb-3">
                  <Form.Group className="form_field">
                    <Form.Label>Description</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Description"
                      className={classNames("", { "is-invalid": errors?.name })}
                      {...register("description", {
                        required: "Description is required",
                      })}
                    />
                    {errors?.description && (
                      <Form.Text className="text-danger">
                        {errors?.description?.message}
                      </Form.Text>
                    )}
                    {showError && (
                      <Form.Text className="text-danger">{showError}</Form.Text>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="col-md-4 mb-3">
                <Form.Group className="form_field"></Form.Group>
                <Form.Label>Image</Form.Label>
                <Form.Control
                  className={classNames("", {
                    "is-invalid": errors?.image,
                  })}
                  type="file"
                  {...register("image", {
                    // required: "Country Logo is required",
                  })}
                  accept=".jpg, .jpeg, .png"
                />
                {errors.image && (
                  <span className="text-danger">{errors.image.message}</span>
                )}
              </div>

              <div className="col-md-4 mb-3">
                <Form.Group className="mb-3">
                  <Form.Label className="text-center">Image Preview</Form.Label>
                  {typeof getValues("image") == "string" ? (
                    <div className="image-preview-container">
                      <img
                        src={IDS.IMG_URL + getValues("image")}
                        alt="Preview"
                        className="image-preview"
                        style={{ width: "150px", height: "130px" }}
                      />
                    </div>
                  ) : (
                    imageFile &&
                    imageFile?.length > 0 && (
                      <div className="image-preview-container">
                        <img
                          // src={URL.createObjectURL(getValues("image")[0])}
                          src={URL?.createObjectURL(imageFile[0])}
                          alt="Preview"
                          className="image-preview"
                          style={{ width: "100px", height: "100px" }}
                        />
                      </div>
                    )
                  )}
                </Form.Group>
              </div>

              <div className="btn_holder">
                {/* <Blue_btn btn_text={"Cancle"} /> */}
                <Blue_border_button button_text={"Save"} type="submit" />
              </div>
            </Form>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <Success_modal
        show={modalSuccessShow}
        onHide={() => setModalsuccessShow(false)}
        message_text={"Operation was successful!"}
        animationData={successAnimation}
      />
    </>
  );
}

export default Edit_offcanvas;
